import { MutationObserverOptions, useMutation } from 'react-query';

import { queryClient, borrowBRToken, IBorrowBRTokenInput, BorrowBRTokenOutput } from 'clients/api';
import FunctionKey from 'constants/functionKey';
import { BRTokenId } from 'types';
import { useBRTokenContract } from 'clients/contracts/hooks';

type Options = MutationObserverOptions<
  BorrowBRTokenOutput,
  Error,
  Omit<IBorrowBRTokenInput, 'brTokenContract'>
>;

const useBorrowBRToken = ({ brTokenId }: { brTokenId: BRTokenId }, options?: Options) => {
  const brTokenContract = useBRTokenContract(brTokenId);

  return useMutation(
    FunctionKey.BORROW_V_TOKEN,
    params =>
      borrowBRToken({
        brTokenContract,
        ...params,
      }),
    {
      ...options,
      onSuccess: (...onSuccessParams) => {
        queryClient.invalidateQueries(FunctionKey.GET_V_TOKEN_BALANCES_ALL);
        queryClient.invalidateQueries(FunctionKey.GET_ASSETS_IN_ACCOUNT);
        queryClient.invalidateQueries(FunctionKey.GET_MARKETS);
        queryClient.invalidateQueries([FunctionKey.GET_V_TOKEN_BORROW_BALANCE, brTokenId]);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );
};

export default useBorrowBRToken;
